import { baseNationCollection } from "./baseNationCollection";

export const citizenshipCollection = [{ name: "Apolide", value: "Apolide" }, ...baseNationCollection];
